/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import ContactUs from "../components/Contactus/ContactUs";
import ContactForm from "../components/Contactus/ContactForm";
import { useLenis } from "../components/SmoothScroll";
export default function ContactUsPage() {
  const lenisRef = useLenis();
  useEffect(() => {
    lenisRef?.current?.scrollTo(0); // top of the page
  }, []);

  return (
    <>
      <title>Contact Citrus Diagnostic Center | Medical Imaging Center</title>
      <meta
        name="description"
        content="Connect with Citrus Diagnostic Center for DEXA scan body fat, abdominal ultrasound, and heart ultrasound at our trusted and advanced medical imaging center."
      />
      <ContactUs />
      <ContactForm />
    </>
  );
}
